import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import color from 'color';
import _ from 'lodash';
import RCore from 'RCore';

const i18Common = require('../../../../i18/i18.Common');
const i18 = RCore.getTranslation.bind({ dict: i18Common });

const TTRow = styled.li`
    display: flex;
    font-size: 18px;
    line-height: 40px;
    list-style: none;
    margin-bottom: 4px;
    position: relative;
    font-weight: ${props => props.theme.fonts.main.bold};

    &:after {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        right: 0px;
        content: ' ';
        z-index: 0;
        transform: skew(-20deg);
        background-color: ${props => (props.high ? props.theme.content.accentColor : props.theme.primaryColor)};
    }

    &:before {
        position: absolute;
        top: 0;
        bottom: 0;
        left: -20px;
        width: 4px;
        content: ' ';
        z-index: 1;
        transform: skew(-20deg);
        background-color: ${props =>
            (props.type && color(props.theme.qualRelColors[props.type]).toString()) || 'transparent'};
    }

    &:nth-child(1) {
        &:after {
            background-color: ${props => props.theme.content.accentColor};
        }
    }

    & > * {
        position: relative;
        z-index: 2;
    }

    color: ${props => (props.high && props.theme.content.accentTextColor) || props.theme.primaryTextColor};

    .tt-rank {
        width: 50px;
        text-align: right;
        padding-right: 20px;
    }
    .tt-team {
        flex-grow: 1;
    }
    .tt-val {
        text-align: right;
    }
    .tt-points {
        color: ${props => (props.high && props.theme.content.accentTextColor) || props.theme.primaryTextColor};
        text-align: right;
        margin-right: 20px;
        font-weight: normal;
    }
`;

const TTHeader = TTRow.extend`
    line-height: 26px;

    &:after {
        background-color: ${props =>
            color(props.theme.primaryColor)
                .darken(0.3)
                .toString()};
    }
`;

const Header = (props, ctx) => {
    const lang = _.get(ctx, 'info.lang', 'en');
    return (
        <TTHeader className='__c__c1_style1'>
            <div className="tt-rank">#</div>
            <div className="tt-team" />
            <div className="tt-val" style={{ width: '50px' }}>
                {i18('matches.short', lang)}
            </div>
            <div className="tt-val" style={{ width: '50px' }}>
                {i18('goals.short', lang)}
            </div>
            <div className="tt-points" style={{ width: '50px' }}>
                {i18('points.short', lang)}
            </div>
        </TTHeader>
    );
};

const Row = ({ row, tournamentId, small, style, qualRel, highlight }) => {
    const dif = (row.goalsScored && row.goalsConceded && row.goalsScored - row.goalsConceded) || 0;
    return (
        <TTRow style={style} first={row.rank === 1} small={small} type={qualRel && row.rankType} high={highlight}>
            <div className="tt-rank">{row.rank}</div>
            <div className="tt-team">{row.teamName}</div>
            <div className="tt-val" style={{ width: '50px' }}>
                {row.matchesPlayed}
            </div>
            <div className="tt-val" style={{ width: '50px' }}>
                {(dif > 0 ? '+' : '-') + dif}
            </div>
            <div className="tt-points" style={{ width: '50px' }}>
                {row.points}
            </div>
        </TTRow>
    );
};

Header.contextTypes = {
    info: PropTypes.object
};

const Container = styled.ul`
    padding: 0;
`;

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/tables/WHTT.js
 **/